import { WebPlugin } from '@capacitor/core';
export class AlipayWeb extends WebPlugin {
    async request(options) {
        return options;
    }
}
//# sourceMappingURL=web.js.map